import React from 'react'

// 기본 색상 9가지
const DEFAULT_COLORS = [
  '#FFECEC',
  '#FBEDE2',
  '#FDF4D4',
  '#E9F8E8',
  '#EEFBE7',
  '#EAF4FB',
  '#E9EFF7',
  '#F2EBFB',
  '#FCE8FD',
]

const ColorSelector = ({
  value,
  defaultValue,
  colors = DEFAULT_COLORS,
  onChange,
  disabled = false,
}) => {
  const displayColors = colors.length > 0 ? colors : DEFAULT_COLORS
  const selectedColor = value ?? defaultValue ?? displayColors[0]

  const handleSelect = (color) => {
    if (disabled) return
    onChange?.(color)
  }

  return (
    <div style={styles.colorGrid}>
      {displayColors.map((color, index) => {
        const isSelected = selectedColor === color
        return (
          <button
            key={index}
            type="button"
            onClick={() => handleSelect(color)}
            disabled={disabled}
            style={{
              ...styles.colorOption,
              background: color,
              border: isSelected ? '1px solid #6D747A' : '1px solid #E1E1DE',
              opacity: disabled ? 0.5 : 1,
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
            title={color}
          />
        )
      })}
    </div>
  )
}

export default ColorSelector

const styles = {
  colorGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    padding: '10px 16px',
    border: '1px solid #E2EAEF',
    borderRadius: '8px',
  },
  colorOption: {
    width: '32px',
    height: '32px',
    aspectRatio: '1/1',
    borderRadius: '6px',
    padding: 0,
    transition: 'transform 0.2s, border 0.2s',
  },
}
